// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../../pplx/frontend/api-clients/core/client.js';
export const autosuggestFinanceClient = createTypedClient();
export const createAutosuggestFinanceClient = (config) => createTypedClient(config);
